/**
 * @module Site Navigation
 * @description Our site navigation
 */
import state from "@/js/config/state";

export default class SiteNavigation {
  constructor() {
    this.el = {
      header: null,
      navCollapse: null,

      // Buttons
      navToggle: null,
    };

    this.state = {
      navOpen: false,
    };

    this.init();
  }

  /**
   * @function openNav
   * @description Open Nav
   */
  openNav() {
    this.state.navOpen = true;
    document.documentElement.setAttribute("data-nav-open", true);
    this.el.navToggle.classList.add("navigation-open");
    this.el.header.classList.add("navigation-open");
    this.el.navCollapse.classList.add("navigation-open");
  }

  /**
   * @function closeNav
   * @description Close Nav
   */
  closeNav() {
    this.state.navOpen = false;
    document.documentElement.setAttribute("data-nav-open", false);
    this.el.navToggle.classList.remove("navigation-open");
    this.el.header.classList.remove("navigation-open");
    this.el.navCollapse.classList.remove("navigation-open");
  }

  /**
   * @function navToggle
   * @description Open / Close Nav
   */
  navToggle() {
    if (!this.state.navOpen) {
      this.openNav();
      return;
    }

    this.closeNav();
  }

  /**
   * @function determineClose
   * @description Allow user to close nav by clicking outside of it
   */
  determineClose(e) {
    if (state.is_desktop) {
      return;
    }

    const { target } = e;

    if (target.tagName === "HEADER") {
      if (this.state.navOpen) {
        this.closeNav();
      }
    }
  }

  /**
   * @function bindEvents
   * @description Bind events for this modules functions
   */
  bindEvents() {
    this.el.navToggle.addEventListener("click", this.navToggle.bind(this));
    this.el.header.addEventListener("click", this.determineClose.bind(this));
  }

  /**
   * @function init
   * @description Kick off this modules functions
   */
  init() {
    this.el.header = document.querySelector(".site-header");

    if (!this.el.header) {
      return;
    }

    // Buttons
    this.el.navToggle = this.el.header.querySelector(".navigation-toggle");

    // Elements
    this.el.navCollapse = this.el.header.querySelector(".navigation-collapse");

    // Bind our buttons / elements with events
    this.bindEvents();
  }
}
